import dayjs from "dayjs"
import BaseInputArea from "../../components/base_elements/BaseInputArea"
import BaseInputField from "../../components/base_elements/BaseInputField"
import BaseModal from "../../components/base_elements/BaseModal"
import { OrderType } from "../types"
import { Timeline } from "antd"
import { transformHistoryIntoTimelineItems } from "../../service/functions"

type OrderDetailModalType = {
    modalId: number
    order: OrderType
}

export default function OrderDetailModal(props: OrderDetailModalType) {
    return (
        <BaseModal title={"Auftragsdetails"} modalId={props.modalId}>
            <div className="flex gap-2 h-full overflow-hidden p-4">
                {/* Information */}
                <div className="flex flex-col gap-2 w-2/3 overflow-y-scroll h-full p-4">
                    <div className="flex gap-2 items-end">
                        <BaseInputField
                            label={"Objekt (eigene Eingabe)"}
                            type={"text"}
                            disabled
                            value={props.order?.objectFromCustomer}
                            onChange={() => {}}
                        />
                        {props.order?.object && (
                            <BaseInputField
                                label={"Objekt (Zuordnung Besitzwerk)"}
                                type={"text"}
                                disabled
                                value={
                                    props.order.object.adress.street +
                                    " " +
                                    props.order.object.adress.nr +
                                    ", " +
                                    props.order.object.adress.plz +
                                    " " +
                                    props.order.object.adress.city
                                }
                                onChange={() => {}}
                            />
                        )}
                    </div>
                    <BaseInputField label={"Auftrag"} type={"text"} disabled value={props.order?.requestTask} onChange={() => {}} />
                    <div className="flex gap-2 items-end">
                        <BaseInputArea
                            label={"Beschreibung des Auftrags (eigene Eingabe)"}
                            disabled
                            value={props.order?.descriptionTaskFromCustomer}
                            onChange={() => {}}
                        />
                        <BaseInputArea
                            label={"Beschreibung des Auftrags (Besitzwerk)"}
                            disabled
                            value={props.order?.descriptionTask}
                            onChange={() => {}}
                        />
                    </div>
                    <BaseInputArea
                        label={"Operative Beschreibung"}
                        disabled
                        value={props.order?.descriptionOrder ?? "keine Angabe"}
                        onChange={() => {}}
                    />
                    <BaseInputField
                        label={"Fälligkeitsdatun"}
                        type={"date"}
                        disabled
                        value={dayjs(props.order?.dueDate).format("YYYY-MM-DD") ?? "keine Angabe"}
                        onChange={() => {}}
                    />
                    <div className="flex gap-2">
                        <BaseInputField
                            label={"Freigabepreis in € (eigene Eingabe)"}
                            type={"text"}
                            disabled
                            value={
                                (props.order?.priceForReleaseFromCustomer
                                    ? props.order?.priceForReleaseFromCustomer?.toFixed(2).replace(".", ",")
                                    : props.order?.priceForReleaseFromCustomer?.toFixed(2).replace(".", ",")) + " €"
                            }
                            onChange={() => {}}
                        />
                        {props.order?.priceForRelease && (
                            <BaseInputField
                                label={"Freigabepreis (Eingabe Besitzwerk)"}
                                type={"text"}
                                disabled
                                value={
                                    (props.order?.priceForRelease
                                        ? props.order?.priceForRelease?.toFixed(2).replace(".", ",")
                                        : props.order?.priceForRelease?.toFixed(2).replace(".", ",")) + " €"
                                }
                                onChange={() => {}}
                            />
                        )}
                    </div>
                    <BaseInputField
                        label={"Ansprechpartner"}
                        type={"text"}
                        disabled
                        value={props.order?.contactPerson ?? "keine Angabe"}
                        onChange={() => {}}
                    />
                    <BaseInputField
                        label={"Telefonnummer"}
                        type={"text"}
                        disabled
                        value={props.order?.contactTel ?? "keine Angabe"}
                        onChange={() => {}}
                    />
                </div>
                {/* TimeLine */}
                <div className="flex flex-col gap-2 w-1/3 h-full p-4 overflow-y-scroll">
                    <Timeline items={transformHistoryIntoTimelineItems(props.order?.history ?? [])} />
                </div>
            </div>
        </BaseModal>
    )
}
